export const folderNew = {
  name: "folder-new" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M1.6 5a.9.9 0 0 1 .9-.9h8a.9.9 0 0 1 .9.9v1.1h10.1a.9.9 0 0 1 .9.9v3a.9.9 0 0 1-1.8 0V7.9H10.5a.9.9 0 0 1-.9-.9V5.9H3.4v12.2h10.1a.9.9 0 0 1 0 1.8h-11a.9.9 0 0 1-.9-.9V5Zm3.5 6a.9.9 0 0 1 .9-.9h9.5a.9.9 0 0 1 0 1.8H6a.9.9 0 0 1-.9-.9Zm14.4 1.1a.9.9 0 0 1 .9.9v2.6H23a.9.9 0 0 1 0 1.8h-2.6V20a.9.9 0 0 1-1.8 0v-2.6H16a.9.9 0 1 1 0-1.8h2.6V13a.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["folder-new"],
  category: "file" as const,
};
